import React, { useContext, useEffect } from 'react';
import './Logout.css';
import CbmContext from '../../Context/Cbm/cbmContext';
import authService from '../../Services/authService';
import { getLogoutFlag, clearLogoutFlag } from '../../Services/storageKeys';
import axios from 'axios';
import { urlBuilding } from '../../config/apiConfig';
// import { Link } from 'react-router-dom';

function Logout() {
  const cbmContext = useContext(CbmContext);
  const { logout, logoutMsg } = cbmContext;

  useEffect(() => {
    if (getLogoutFlag()) {
      logout();
    }
    // clearLogoutFlag();
    if (getLogoutFlag()) {
      clearLogoutFlag();
    }
  }, [logout]);

  useEffect(() => {
    const performLogout = async () => {
      const refreshToken = authService.getRefreshToken();

      // Call backend to revoke refresh token if it exists
      if (refreshToken) {
        try {
          const backendUrl =
            window.location.hostname.indexOf('stage') > -1
              ? urlBuilding.stageUrl
              : urlBuilding.localUrl;

          await axios.post(`${backendUrl}/api/v1/auth/logout`, {
            refreshToken,
          });
        } catch (error) {
          console.error('Logout error:', error);
          // Continue with local logout even if backend call fails
        }
      }

      // Clear all tokens and auth data
      if (authService.hasToken()) {
        authService.clearToken();
      }
      if (localStorage.getItem('goToLogout')) {
        localStorage.removeItem('goToLogout');
      }
    };

    performLogout();
  }, []);
  return (
    <div className="logout-content">
      <div className="logoutMsg">
        <p>
          {logoutMsg !== ''
            ? logoutMsg
            : "You've been logged out successfully."}
        </p>
        <p>
          Click <a href="/login">here</a> to go to the login page
        </p>
      </div>
    </div>
  );
}

export default Logout;
